module.exports = __webpack_public_path__ + "img/firestone2.2203d851.png";